<template>
  <div class="switch-button switch-button-yesno">
    <input type="checkbox" :id="id" ref="switchInput" @change="onChange" :checked="on" />
    <span>
      <label :for="id"></label>
    </span>
  </div>
</template>

<script>
export default {
  name: 'SwitchButton',
  components: {},
  props: {
    id: [String, Boolean],
    on: {
      type: [String, Boolean],
      default: true
    },
    trueText: {
      type: String,
      default: 'Yes'
    },
    falseText: {
      type: String,
      default: 'No'
    }
  },
  mounted () {
  },
  data: () => ({
    checked: false
  }),
  methods: {
    onChange (e) {
      this.$emit('input', e.target.checked)
    }
  }
}
</script>

<style lang="scss">
    @import "switch-button";
</style>



// WEBPACK FOOTER //
// src/components/SwitchButton/switch-button.vue